export default {"src":"/_next/static/media/SubDesc8.f5fee5f8.svg","height":121,"width":120,"blurWidth":0,"blurHeight":0};